import "./index.scss";

import LoadingState from "components/atoms/LoadingState";
import React from "react";

interface ErrorBoundaryProps {}

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // You can also log the error to an error reporting service
    // const errorToPush = {
    //   createdAt: new Date().toString(),
    //   error,
    //   errorInfo,
    // };
    debugger;
    // window.location.reload();
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return <LoadingState />;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
